module.exports = __webpack_public_path__ + "static/media/coming-soon.802dc6bf.png";